import axios from 'axios'

export const SIGN_IN_PATH = '/users/sign_in'

// The CSRF token comes from csrf_meta_tags and is baked into the page at render
// time. Long-lived screens never reload, so re-reading it here does not make a
// stale token fresh — that is what handleUnauthorized below is for.
export const setupAxiosCSRF = () => {
  const tokenDom = document.querySelector("meta[name=csrf-token]")
  if (tokenDom) {
     const csrfToken = tokenDom.content
     axios.defaults.headers.common['X-CSRF-Token'] = csrfToken
  }
  setupAxiosAuthHandling()
};

// The token for a raw fetch, read from csrf_meta_tags (blank when absent).
export const csrfToken = () => {
  const tag = document.querySelector('meta[name=csrf-token]')
  return tag ? tag.content : ''
};

// Sends the user to the sign-in page after their session has gone away, unless
// they are already there. Returns true when it acted, so raw fetch callers can
// bail out of their success path.
export const handleUnauthorized = () => {
  if (window.location.pathname === SIGN_IN_PATH) return false

  window.location.assign(SIGN_IN_PATH)
  return true
};

// Pulls the server's own message out of an axios error where there is one, so
// the user sees "Your session expired..." rather than a generic failure.
export const errorMessageFor = (error, fallback) => {
  const serverMessage = error && error.response && error.response.data && error.response.data.error

  return serverMessage || fallback
};

// Devise answers an expired session on a non-navigational request with a 401,
// and ApplicationController does the same for a stale CSRF token. Without this
// every caller's .catch just logs and the user is left with a dead button.
let authInterceptorRegistered = false

export const setupAxiosAuthHandling = () => {
  if (authInterceptorRegistered) return
  authInterceptorRegistered = true

  axios.interceptors.response.use(
    response => response,
    error => {
      if (error.response && error.response.status === 401) {
        handleUnauthorized()
      }
      return Promise.reject(error)
    }
  )
};
